import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { inject } from '@angular/core';
import { I18nProviderInjectionToken } from '../../i18n/i18n.scope';

export class PaginatorI18n {
  readonly #i18nScope = inject<string>(I18nProviderInjectionToken);
  readonly #transloco = inject(TranslocoService);

  getPaginatorIntl(): MatPaginatorIntl {
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = '';
    paginatorIntl.firstPageLabel = this.#transloco.translate(
      `${this.#i18nScope}.PAGINATOR.FIRST_PAGE`,
    );
    paginatorIntl.previousPageLabel = this.#transloco.translate(
      `${this.#i18nScope}.PAGINATOR.PREVIOUS_PAGE`,
    );
    paginatorIntl.nextPageLabel = this.#transloco.translate(
      `${this.#i18nScope}.PAGINATOR.NEXT_PAGE`,
    );
    paginatorIntl.lastPageLabel = this.#transloco.translate(
      `${this.#i18nScope}.PAGINATOR.LAST_PAGE`,
    );
    paginatorIntl.getRangeLabel = this.#getRangeLabel.bind(this);
    return paginatorIntl;
  }

  #getRangeLabel(pageIndex: number, pageSize: number, length: number): string {
    if (length === 0) {
      return '0 / 0';
    }
    return `${pageIndex + 1} / ${Math.ceil(length / pageSize)}`;
  }
}
